import { getDay, isEqual, startOfMonth } from 'date-fns/fp'
import { format } from 'date-fns'

import { DATE_FORMATS } from '../constants'

/**
 * Check if assigned date is weekend day
 *
 * @export
 * @param {Date} date
 * @returns {boolean}
 */
export function isWeekend(date: Date): boolean {
  const day = date.getDay()
  return day === 6 || day === 0
}

/**
 * Check if assigned date is the future date
 *
 * @export
 * @param {Date} date
 * @returns {boolean}
 */
export function isFutureDate(date: Date): boolean {
  const currentDate = new Date()
  currentDate.setHours(0, 0, 0, 0)
  date.setHours(0, 0, 0, 0)
  return date > currentDate
}

/**
 * Check if assigned date is between days, strat & end are included
 *
 * @export
 * @param {Date} date
 * @param {Date} startDate
 * @param {Date} endDate
 * @returns {boolean}
 */
export function isBetweenDays(date: Date, startDate: Date, endDate: Date): boolean {
  date.setHours(0, 0, 0, 0)
  startDate.setHours(0, 0, 0, 0)
  endDate.setHours(0, 0, 0, 0)
  if(date >= startDate && date <= endDate){
    return true
  } else {
    return false
  }
}

/**
 * Closure function for check if the assigned date is present in custom array of dates.
 *
 * @export
 * @param {Date[]} dates
 * @returns {(param: Date) => void}
 */
export function isBusinessDay(dates: Date[]): (param: Date) => void {
  return (date: Date) => {
    for (let i = 0; i <= dates.length; i++) {
      if (isEqual(dates[i], date)) {
        return true
      }
    }
    return false
  }
}

/**
 * Custom date validation
 *
 * @export
 * @param {number} year
 * @param {number} month
 * @param {number} day
 * @returns {boolean}
 */
export function isValidDate(year: number, month: number, day: number): boolean {
  const date = new Date(year, month, day)
  if (
    date.getFullYear() === year &&
    date.getMonth() === month &&
    date.getDate() === day
  ) {
    return true
  }
  return false
}

/**
 * Get first day of month when week start in monday
 *
 * @export
 * @param {Date} date
 * @returns {number}
 */
export function getFirstDayOfMonth(date: Date): number {
  const first = getDay(startOfMonth(date))
  if (first === 0) {
    return 6
  } else {
    return first - 1
  }
}

export const getIsoDate = (date: Date) =>
  format(date, DATE_FORMATS.DATE) +
  'T' +
  format(date, DATE_FORMATS.ONLY_TIME_SECONDS)
